import PodcastitemScreen from './containers/podcastitemScreen'

export {default as PodcastitemScreenLayout} from './components/podcastitemScreenLayout'

export default PodcastitemScreen
